export const LINE_ADD_FRIEND_BASE_URL = process.env.REACT_APP_LINE_ADD_FRIEND_BASE_URL ||
    'https://line.me/R/ti/p/@';
